'use client';

import type { JSX, MutableRefObject } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableItem = ({
  id,
  value,
  position,
  inputRef,
  isDragging,
}: {
  id: string;
  value: JSX.Element;
  position: number;
  inputRef: MutableRefObject<any>;
  isDragging: boolean;
}) => {
  const shouldHaveRef = position === 0;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? transition : 'none',
    zIndex: isDragging ? 1 : 0,
    position: 'relative' as const,
  };

  return (
    <li
      ref={(node) => {
        setNodeRef(node);
        if (shouldHaveRef && node) {
          inputRef.current = node;
        }
      }}
      style={style}
      tabIndex={0}
      className="list-drag"
      {...attributes}
      {...listeners}
    >
      <div className="index-drag">
        {position + 1}
        &nbsp;-&nbsp;
      </div>
      <div className="label-drag">{value}</div>
      <div className="handle" />
    </li>
  );
};
